import type { FaireProductEntity } from "../../entity_types/product";

export const p_jkz6er794p: FaireProductEntity = {
  token: "p_jkz6er794p",
  type: "product",
  name: "V-PLACKET POLO KNIT TOP AND SHORTS SET",
  brandToken: "b_2a388unpqo",
  brandName: "Bluivy",
  imageUrl:
    "https://cdn.faire.com/fastly/62e27bd6ee630c73b0a102b24a5d40fc1136f29b6fd6febbab222584e8211c81.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/50aeb51b0c1f7329fc17b8e527245c93de4cc724512c1d23e0640808b2815b6f.jpeg",
    "https://cdn.faire.com/fastly/4640db024f2b55324f3af39e98fe71e78851fddbae25ceecc0d9cecdbbf75109.jpeg",
    "https://cdn.faire.com/fastly/7e3a2d9a70b6bb8341d06c13868fd10a49d05dc1505598ce175dc0039ecc21e7.jpeg",
    "https://cdn.faire.com/fastly/4079947fc84e05c77e258b10a4a99f1edff30ebf47e7dcfb2298f9996ef91e8c.jpeg",
    "https://cdn.faire.com/fastly/6ba5fd65be14c8979f8c087d5d90289173210dfa529499f1c41376772fa6ce59.jpeg",
    "https://cdn.faire.com/fastly/d4c20aea7621034962488f4ac801e2c6511084c5a42a3f7d302f1c866c770571.jpeg",
    "https://cdn.faire.com/fastly/986bb33530db6fe1d33547370c509cc657765afd2a8a7d4be66f2c3b681c5c7e.jpeg",
    "https://cdn.faire.com/fastly/da91bad22bb2fc98e744e1945805f405abb2501c195cc5efca020754494f3da8.jpeg",
    "https://cdn.faire.com/fastly/5952e5c7b869062e74b34581da302d28c1aac9b6f3553a2ae9849ea6d8e81d75.jpeg",
    "https://cdn.faire.com/fastly/d2af2a88f56a6bd2f97c7aa7f0fc272a5296811ed64f3fa2e59674e2b4cd55d7.jpeg",
    "https://cdn.faire.com/fastly/87d10a54da9eebc68a20c19567928a3bfd670d6f5d8ef823434bdae18a6220cb.jpeg",
    "https://cdn.faire.com/fastly/56edd8f86660b35958067e3dce7d406f8bc54039f4a14aea3e6579b35f79c5d9.jpeg",
    "https://cdn.faire.com/fastly/148699ab52c63df01e1f28d5c9f3747845df70ecabf2ab0bf31b3f576318bfca.jpeg",
    "https://cdn.faire.com/fastly/fd162a85f3772cc1806f2f247a07939f1915578ad1f057a1efdb56d3c86ee6df.jpeg",
    "https://cdn.faire.com/fastly/68abb54fa44ca72d3276fa17af6529c75243e2f649c4ce013eb381e553909599.jpeg",
    "https://cdn.faire.com/fastly/1e4914cf07479f04e0daf53f53eb400c0c54e123bfc6e0c83796bd36832d8cf6.jpeg",
    "https://cdn.faire.com/fastly/20dd212650a9af131d09d04c2fdb3eda3a5471f6306e8ed499443d699dab0437.jpeg",
    "https://cdn.faire.com/fastly/c3e58f00fbe2303bb2e4912eaea0771d68b03da85d37cad9cc8b485f556f2938.jpeg",
    "https://cdn.faire.com/fastly/8b01df2dd353e393f5dd5a86ad711c23e9120d2878a31f0ccf28afd670edbf75.jpeg",
    "https://cdn.faire.com/fastly/8d083a212009804a6fcf5e65aa89a3eea1880895d21f43195a534d5026de9dad.jpeg",
    "https://cdn.faire.com/fastly/6b0a12edbd15d38489032f3ecc03e639230edd0a45a14090aac05480cac28092.jpeg",
    "https://cdn.faire.com/fastly/1a89761eeb7acaf0fe5c5b0acd24acd688d00786202c4034d2eb717eacb11dcb.jpeg",
    "https://cdn.faire.com/fastly/a0072702a41700f6c9b931b1aa8fd8e7feb7191d8b2eb90306b2a3bb1ac62cf2.jpeg",
    "https://cdn.faire.com/fastly/f06a05b402322a3c692ba32b8d55484cea90404486b35454c4133d283f96452b.jpeg",
    "https://cdn.faire.com/fastly/27674a18554c077b6504f174cea73c9f685722aa452912b9540bd74ee9875e17.jpeg",
    "https://cdn.faire.com/fastly/b748a9ffd247d65ebafe4f41127b0d228e842f11191da9ab953ed4c6003aece2.jpeg",
    "https://cdn.faire.com/fastly/0ac1983c5d8e03a085a3cd000be49053c3f49f877cc0ea3b626c7f33838fb513.jpeg",
    "https://cdn.faire.com/fastly/a28172944143e24ec6ba41476501fd2789a36a65b69864da682f3eb380d3297f.jpeg",
    "https://cdn.faire.com/fastly/09799a75640e029befaa0ffa7b51257e02f308097ed8806bf92f8b163ea1fa3c.jpeg",
    "https://cdn.faire.com/fastly/75793924682eb167fd00b43a461f0450587149cdcce62e3d6ff27d0bdc285b29.jpeg",
    "https://cdn.faire.com/fastly/88b235018be54d1f1502787634bb3d3b7ecf697731759ea1a3995a4e32ddde33.jpeg",
    "https://cdn.faire.com/fastly/7737dbeba95311996b7f8d9614ccd87a1a0381f4ca7efe1633e875b2f1fb347e.jpeg",
  ],
  priceDollars: 28.8,
  description:
    "This coordinated two-piece set is crafted from a soft, lightweight knit fabric in a brown and neutral oatmeal hue, offering a relaxed and comfortable silhouette. The top is a polo-inspired sweater featuring a classic collar with a buttonless V-placket, short dropped-shoulder sleeves, and a subtle vertical center seam that adds a modern touch to its boxy fit. Completing the look are the matching shorts, which are designed with a wide ribbed waistband and coordinating ribbed cuffs at the hem, along with functional large patch pockets on the front for a practical, loungewear-inspired aesthetic.\n\n-Model is 5'9\" and wearing a Small",
  tags: [],
  msrpDollars: 57.6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:01.346Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
